import styled from '@emotion/styled';
import { Button } from 'ds/components/button';
import { H3, SmallText, Text } from 'ds/components/typography';
import { colorToAlpha } from 'helpers/insight';


export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.media.showAt({ to: 2 })`flex-direction: column`};
  background: ${({ theme }) => colorToAlpha(theme.colors.brand.main, 0.05)};
  padding: ${({ theme }) => theme.spacing(3)};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  border: 1px solid transparent;
`;


export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 267px;
  margin: 0 ${({ theme }) => theme.spacing(2)};;
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    width: 257px;
  `}
`;

export const SaveButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.brand.main};
  color: ${({ theme }) => theme.colors.neutrals.white};
  white-space: nowrap;
  box-shadow: none;
  margin-${({ theme }) => theme.isRTL ? 'right' : 'left'}: auto;
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    margin-top: ${theme.spacing(3)};
    width: 100%;
    max-width: 267px;
  `}
`;


export const ContentTitle = styled(Text)`
  color: ${({ theme }) => theme.colors.brand.main};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    text-align: center;
  `}
`;

export const ContentDescription = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    text-align: center;
  `}
`;

export const NoResultsWrapper = styled.div`
  padding: 0 0 ${({ theme }) => theme.spacing(4)};
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
  margin-top: ${({ theme }) => theme.spacing(4)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const TextHeader = styled(H3)`
  padding: 0 0 ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) => theme.colors.neutrals.grey1};
`;

export const Hint = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey3};
`;

export const SaveSearchButtonWrapper = styled.div`
   margin-top: ${({ theme }) => theme.spacing(3)};
`;
